export enum ProviderType {
  OMOP_MAPPING = 'omop_mapping',
  PLANNER = 'planner',
}

export const AGENT_LABELS: Record<ProviderType, string> = {
  [ProviderType.OMOP_MAPPING]: 'OMOP Mapping',
  [ProviderType.PLANNER]: 'Planner',
};

export const AVAILABLE_AGENTS = [ProviderType.OMOP_MAPPING, ProviderType.PLANNER] as const;

export enum TargetType {
  AGENT = 'agent',
}
